export const LANE_H = 32;

export const DOWNTIME_BG =
  "repeating-linear-gradient(45deg, rgba(239,68,68,0.16), rgba(239,68,68,0.16) 6px, rgba(239,68,68,0.28) 6px, rgba(239,68,68,0.28) 12px)";
export const OFFDAY_BG =
  "repeating-linear-gradient(45deg, rgba(100,116,139,0.06), rgba(100,116,139,0.06) 8px, rgba(100,116,139,0.13) 8px, rgba(100,116,139,0.13) 16px)";

export function startOfWeek(d) {
  const date = new Date(d);
  const day = (date.getDay() + 6) % 7; // Monday = 0
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() - day);
  return date;
}

export function sameDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

export function isOffDay(date, workingDays) {
  if (!workingDays || !workingDays.length) return false;
  const pyDay = (date.getDay() + 6) % 7; // JS Sun=0 → Python Mon=0
  return !workingDays.includes(pyDay);
}

export function fmtDuration(o) {
  if (o.estimated_hours == null) return null;
  const h = o.estimated_hours;
  return h >= 24 ? `${(h / 24).toFixed(1)}d` : `${h}h`;
}

// Bar span for an order: start_date → estimated_completion, clipped to the visible window.
export function barGeometry(o, winStart, winEnd) {
  if (!o.start_date) return null;
  const start = new Date(o.start_date);
  let end = o.estimated_completion ? new Date(o.estimated_completion) : new Date(start.getTime() + 4 * 3600e3);
  if (end.getTime() - start.getTime() < 2 * 3600e3) end = new Date(start.getTime() + 2 * 3600e3);
  if (end <= winStart || start >= winEnd) return null;
  const total = winEnd - winStart;
  const left = Math.max(0, ((start - winStart) / total) * 100);
  const right = Math.min(100, ((end - winStart) / total) * 100);
  return { left, width: Math.max(right - left, 1.5), clipL: start < winStart, clipR: end > winEnd, start, end };
}

// Generic time-range → percentage geometry (used for downtime windows).
export function rangeGeometry(startRaw, endRaw, winStart, winEnd) {
  const start = new Date(startRaw);
  const end = new Date(endRaw);
  if (!startRaw || !endRaw || end <= winStart || start >= winEnd) return null;
  const total = winEnd - winStart;
  const left = Math.max(0, ((start - winStart) / total) * 100);
  const right = Math.min(100, ((end - winStart) / total) * 100);
  return { left, width: Math.max(right - left, 0.5) };
}

// Greedy lane assignment so overlapping bars stack instead of colliding.
export function assignLanes(items) {
  const laneEnds = [];
  return items.map((it) => {
    let lane = laneEnds.findIndex((endT) => it.geo.start >= endT);
    if (lane === -1) {
      lane = laneEnds.length;
      laneEnds.push(it.geo.end);
    } else {
      laneEnds[lane] = it.geo.end;
    }
    return { ...it, lane };
  });
}
